import { VIDEOS_LOADING, VIDEOS_SUCCESS, VIDEOS_FAILURE } from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { videosUrl } from "api/apiUrls";

export const videosActions = (type: string) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: VIDEOS_LOADING, payload: true });
    const response = await listItemsService(
      `${videosUrl}`,
      `file_type=${type}`
    );

    dispatch({ type: VIDEOS_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: VIDEOS_FAILURE, payload: err });
  } finally {
    dispatch({ type: VIDEOS_LOADING, payload: false });
  }
};
